module.exports = __webpack_public_path__ + "img/deep_dive_bg_1.fa74aac5.png";